import { render, staticRenderFns } from "./CardViewTab.vue?vue&type=template&id=1aaf79c9&scoped=true&"
import script from "./CardViewTab.vue?vue&type=script&lang=js&"
export * from "./CardViewTab.vue?vue&type=script&lang=js&"
import style0 from "./CardViewTab.vue?vue&type=style&index=0&id=1aaf79c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf79c9",
  null
  
)

export default component.exports